import * as actions from './actions'
import * as types from '../../actionTypes'
import lmsApi from '../../../lib/CfcLmsApi'

export const fetchTrainingStatusesCss = email => {
  return async dispatch => {
    dispatch(actions.fetchingTrainingStatusesCss())
    try {
      const apiResponse = await lmsApi.getLMSTrainingStatusCss(email)
      const { data } = apiResponse
      data.training_report = data.training_report
        .filter(x => x.sco <= 3 && x.sco !== 1)
        .map(r => {
          const matchedTrack = data.training_track.find(
            track => track.program === r.skuCode.toLowerCase(),
          )
          const { title } =
            (matchedTrack.users_current_track &&
              matchedTrack.users_current_track) ||
            ''
          r.current_track_title = title || ''
          return r
        })
      dispatch(actions.fetchingTrainingStatusesSuccessCss(data))
      return true
    } catch (error) {
      dispatch(actions.fetchingTrainingStatusesErrorCss(error))
      return false
    }
  }
}

export const addTraining = (learner, program, trackSco, userId) => {
  return async dispatch => {
    dispatch(actions.addTrainingPathStatus())
    try {
      const response = await lmsApi.postLMSTrainingTrack(
        learner,
        program,
        trackSco,
        userId,
      )
      dispatch(actions.addTrainingPathStatusSuccess(response.status))
      return response.data
    } catch (e) {
      dispatch(actions.addTrainingPathStatusError(e))
      return false
    }
  }
}

export const updateTraining = (
  learner,
  trackSco,
  childScos,
  programInstance,
) => {
  return async dispatch => {
    dispatch(actions.updateTrainingPathStatus())
    try {
      const response = await lmsApi.putLMSTrainingTrack(
        learner,
        trackSco,
        childScos,
        programInstance,
      )
      dispatch(actions.updateTrainingPathStatusSuccess(null))
      return response.data
    } catch (e) {
      dispatch(actions.updateTrainingPathStatusError(e))
      return false
    }
  }
}

export const fetchChildModuleStatus = (learner, trackId, program) => {
  return async dispatch => {
    dispatch(actions.fetchingChildModuleStatus())
    try {
      const { data } = await lmsApi.getLMSChildModuleStatus(learner, trackId)
      const moduleFilter = data.filter(
        module => module.sco > 3 && !module.title.includes('Resources'),
      )
      dispatch(actions.fetchingChildModuleStatusSuccess(moduleFilter, program))
    } catch (error) {
      dispatch(actions.fetchingChildModuleStatusError(error))
      return false
    }
  }
}

export const setActiveSkuCode = skuCode => ({
  type: types.SET_ACTIVE_SKU_CODE,
  skuCode,
})

export const savingTraining = saving => ({
  type: types.IS_SAVING_TRAINING,
  saving,
})

export const clearChildModuleStatus = program => ({
  type: types.CLEAR_LMS_CHILD_MODULE_STATUSES,
  program,
})

export default {
  addTraining,
  clearChildModuleStatus,
  fetchChildModuleStatus,
  fetchTrainingStatusesCss,
  savingTraining,
  setActiveSkuCode,
  updateTraining,
}
